import { SideBarItemEnum } from '../pages/BaseIndex/helpers/SideBarItems';
import { WorkspaceViewGroup } from '../types/WorkspaceView';

export const getWorkspaceViewGroup = (pathname: string): WorkspaceViewGroup => {
  if (pathname.includes(SideBarItemEnum.triage)) {
    return WorkspaceViewGroup.triage;
  } else if (pathname.includes(SideBarItemEnum.archive)) {
    return WorkspaceViewGroup.archive;
  } else if (pathname.includes(SideBarItemEnum.planning)) {
    return WorkspaceViewGroup.planning;
  } else if (pathname.includes(SideBarItemEnum.sprint)) {
    return WorkspaceViewGroup.sprint;
  } else if (pathname.includes(SideBarItemEnum.kanban)) {
    return WorkspaceViewGroup.kanban;
  } else if (pathname.includes(SideBarItemEnum.epics)) {
    return WorkspaceViewGroup.epics;
  } else {
    return WorkspaceViewGroup.backlog;
  }
};
